/**
 * Auto Gift Handler + Chặn duplicate add-to-cart request
 */
(function() {
  // ========================================
  // PHẦN 1: Chặn duplicate add-to-cart request
  // ========================================
  const addToCartLocks = new Map(); // Map<variantId, timestamp>
  const LOCK_DURATION = 2000; // 2 giây - chặn add cùng variant trong khoảng này
  
  const originalFetch = window.fetch;
  window.fetch = async function(url, options = {}) {
    const urlStr = typeof url === 'string' ? url : url.toString();
    
    // Chỉ intercept request POST đến /cart/add.js
    if (urlStr.includes('/cart/add') && options.method === 'POST') {
      let variantId = null;
      
      // Lấy variant ID từ body
      if (options.body instanceof FormData) {
        variantId = options.body.get('id');
      } else if (typeof options.body === 'string') {
        try {
          const parsed = JSON.parse(options.body);
          variantId = parsed.id || (parsed.items && parsed.items[0]?.id);
        } catch(e) {}
      }
      
      if (variantId) {
        const now = Date.now();
        const lastAdd = addToCartLocks.get(String(variantId));
        
        // Nếu variant này vừa được add trong vòng LOCK_DURATION ms → block
        if (lastAdd && (now - lastAdd) < LOCK_DURATION) {
          console.log('🛑 Blocked duplicate add-to-cart for variant:', variantId);
          // Trả về response giả để không crash code gọi
          return new Response(JSON.stringify({ 
            items: [{ variant_id: variantId, quantity: 1 }] 
          }), {
            status: 200,
            headers: { 'Content-Type': 'application/json' }
          });
        }
        
        // Đánh dấu variant này đang được add
        addToCartLocks.set(String(variantId), now);
        console.log('✅ Add-to-cart allowed for variant:', variantId);
      }
    }
    
    // Gọi fetch gốc
    return originalFetch.apply(this, arguments);
  };
  
  // ========================================
  // PHẦN 2: Xử lý gift duplicates (chỉ chạy nếu có gift product)
  // ========================================
  const giftVariantId = window.giftVariantId ? String(window.giftVariantId) : null;
  
  if (!giftVariantId) {
    console.log('🎁 No gift product, only duplicate-block active');
    return; // Vẫn giữ phần intercept fetch ở trên
  }
  
  let isProcessing = false;
  let pendingMerge = null;
  
  // Listen cart update events
  document.addEventListener('cart:updated', () => scheduleMerge(1000));
  document.addEventListener('cart:item-added', () => scheduleMerge(1500));
  
  // Listen cart drawer open
  const cartDrawer = document.getElementById('Cart-Drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      if (!cartDrawer.hasAttribute('inert')) {
        scheduleMerge(500);
      }
    });
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['inert'] });
  }
  
  function scheduleMerge(delay) {
    if (isProcessing || pendingMerge) return;
    
    pendingMerge = setTimeout(() => {
      pendingMerge = null;
      handleAutoGift();
    }, delay);
  }

  async function handleAutoGift() {
    if (isProcessing) return;
    isProcessing = true;
    
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      
      // Phân loại items: quà vs sản phẩm thường
      const giftItems = [];
      const normalItems = [];
      
      cart.items.forEach((item, index) => {
        if (String(item.variant_id) === giftVariantId) {
          giftItems.push({ ...item, index });
        } else {
          normalItems.push({ ...item, index });
        }
      });
      
      const hasNormalItems = normalItems.length > 0;
      const hasGift = giftItems.length > 0;
      
      console.log('🎁 Cart status:', { normalItems: normalItems.length, giftItems: giftItems.length });
      
      // CASE 1: Có sản phẩm thường nhưng CHƯA có quà → Thêm quà
      if (hasNormalItems && !hasGift) {
        console.log('🎁 Adding gift to cart...');
        await addGiftToCart();
        return;
      }
      
      // CASE 2: KHÔNG có sản phẩm thường nhưng CÓ quà → Xoá quà
      if (!hasNormalItems && hasGift) {
        console.log('🎁 Removing gift (no normal items)...');
        await removeAllGifts(giftItems);
        return;
      }
      
      // CASE 3: Có sản phẩm thường VÀ có quà → Check duplicate gift
      if (hasNormalItems && hasGift) {
        // Nếu chỉ có 1 line gift và qty = 1 thì OK
        if (giftItems.length === 1 && giftItems[0].quantity === 1) {
          console.log('🎁 Gift OK (1 line, qty=1)');
          isProcessing = false;
          return;
        }
        
        // Có duplicate hoặc qty > 1 → Fix
        console.log('🎁 Fixing gift duplicates...');
        await fixGiftDuplicates(giftItems);
        return;
      }
      
      // CASE 4: Giỏ hàng trống → không làm gì
      console.log('🎁 Cart empty, nothing to do');
      isProcessing = false;
      
    } catch(e) {
      console.error('Auto gift error:', e);
      isProcessing = false;
    }
  }
  
  // Thêm quà vào giỏ hàng
  async function addGiftToCart() {
    try {
      const addRes = await originalFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftVariantId,
          quantity: 1
        })
      });
      
      if (!addRes.ok) {
        console.error('❌ Add gift failed:', addRes.status);
        isProcessing = false;
        return;
      }
      
      console.log('✅ Gift added!');
      setTimeout(updateCartDrawer, 300);
      
    } catch(e) {
      console.error('Add gift error:', e);
      isProcessing = false;
    }
  }
  
  // Xoá tất cả quà khỏi giỏ hàng
  async function removeAllGifts(giftItems) {
    try {
      const updates = {};
      giftItems.forEach(item => {
        updates[item.key] = 0;
      });
      
      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      
      if (!updateRes.ok) {
        console.error('❌ Remove gift failed:', updateRes.status);
        isProcessing = false;
        return;
      }
      
      console.log('✅ Gift removed!');
      setTimeout(updateCartDrawer, 300);
      
    } catch(e) {
      console.error('Remove gift error:', e);
      isProcessing = false;
    }
  }
  
  // Fix duplicate gift: giữ 1 line với qty = 1
  async function fixGiftDuplicates(giftItems) {
    try {
      const updates = {};
      
      giftItems.forEach((item, idx) => {
        if (idx === 0) {
          updates[item.key] = 1; // Giữ line đầu với qty = 1
        } else {
          updates[item.key] = 0; // Xoá các line còn lại
        }
      });
      
      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      
      if (!updateRes.ok) {
        console.error('❌ Fix gift failed:', updateRes.status);
        isProcessing = false;
        return;
      }
      
      console.log('✅ Gift fixed!');
      setTimeout(updateCartDrawer, 300);
      
    } catch(e) {
      console.error('Fix gift error:', e);
      isProcessing = false;
    }
  }
  
  async function updateCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-bubble');
      const sections = await res.json();
      
      if (!sections['cart-drawer']) {
        location.reload();
        return;
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      
      // Update product list
      const newList = doc.querySelector('.product-card-small--container');
      const currentList = document.querySelector('.product-card-small--container');
      if (newList && currentList) {
        currentList.innerHTML = newList.innerHTML;
      }
      
      // Update footer
      const newFooter = doc.querySelector('.side-panel-footer');
      const currentFooter = document.querySelector('.side-panel-footer');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }
      
      // Update count badge
      if (sections['cart-bubble']) {
        const bubbleDoc = parser.parseFromString(sections['cart-bubble'], 'text/html');
        document.querySelectorAll('.thb-item-count').forEach(el => {
          const newCount = bubbleDoc.querySelector('.thb-item-count');
          if (newCount) el.innerHTML = newCount.innerHTML;
        });
      }
      
      console.log('✅ Cart UI updated!');
      
    } catch(e) {
      console.error('Update error:', e);
      location.reload();
    } finally {
      isProcessing = false;
    }
  }
})();
